/* --------------------------------------------------------------
 * Questlog Header (Claude, 23.10.2026): Handy-Menue auf/zu.
 * Die Suche steuert assets/ql-header-search.js.
 * -------------------------------------------------------------- */
(function () {
  var header = document.querySelector('[data-ql-header]');
  if (!header) return;
  var menu = header.querySelector('[data-ql-menu]');
  var openBtn = header.querySelector('[data-ql-menu-open]');
  if (!menu || !openBtn) return;
  var panel = menu.querySelector('.ql-menu__panel');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    menu.hidden = false;
    menu.getBoundingClientRect();
    menu.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('ql-menu-open');
    var first = panel.querySelector('a, button');
    if (first) first.focus();
  }

  function close() {
    menu.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('ql-menu-open');
    var done = function () { if (!menu.classList.contains('is-open')) menu.hidden = true; };
    panel.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  openBtn.addEventListener('click', open);
  menu.addEventListener('click', function (e) {
    if (e.target.closest('[data-ql-menu-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
  });
})();

/* --------------------------------------------------------------
 * Klicks auf die Einstiege in den Wandkonfigurator messen (02.11.2026).
 * Ereignis ql_wand_einstieg_<ort>, Ort aus data-ql-wand-einstieg (hero,
 * section, kachel, pdp), Links im Header zaehlen als menue. Der Name
 * loest in GTM den Ausloeser „CE – ql_wand_*“ aus und laeuft so nach GA4;
 * GTM laedt nur mit Einwilligung.
 * -------------------------------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="/pages/wandkonfigurator"]') : null;
    if (!a) return;
    var ort = a.getAttribute('data-ql-wand-einstieg') || (a.closest('[data-ql-header]') ? 'menue' : 'sonstige');
    var name = 'ql_wand_einstieg_' + ort;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, {}); } catch (err) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name }); } catch (err) {}
  });
})();
